import React from "react";
import { differenceInYears, format, parseISO, differenceInCalendarDays } from "date-fns";
import { dateOnlyISO8601 } from "../../library/date";
import { Tooltip } from "@mui/material";

export interface DateCellProps {
  value: string,
  type: string
}

function DateCell({ value, type }: DateCellProps): React.ReactElement {
  let dateISO = parseISO(dateOnlyISO8601(value))
  switch (type) {
    case "session":
      return (
        <Tooltip title={`Ran ${differenceInCalendarDays(new Date(), dateISO)} days ago`} placement="right">
          <span>{format(dateISO, 'MM/dd/yyyy')}</span>
        </Tooltip>
      )
    default:
      return (
        <Tooltip title={`Age ${differenceInYears(new Date(), dateISO)}`} placement="right">
          <span>{format(dateISO, 'MM/dd/yyyy')}</span>
        </Tooltip>
      )
  }

}

export default DateCell;